import React from 'react';

const Badge = React.forwardRef(
  ({ className = '', variant = 'default', ...props }, ref) => {
    const baseClasses =
      'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors';

    // Make variants optional, but not overriding custom className colors
    const variants = {
      default: '',
      secondary: '',
      destructive: '',
      outline: ''
    };

    // Apply only baseClasses + custom className
    const classes = `${baseClasses} ${variants[variant]} ${className}`;

    return <div className={classes} ref={ref} {...props} />;
  }
);

Badge.displayName = 'Badge';

export { Badge };
